import React, { useEffect, useRef } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';

const CarouselSettings = {
    showStatus: false,
    showThumbs: false,
};


const Slider = ({ values, bootstrapComponents }) => {
 
    const myRef = useRef(null);
    useEffect(() => {
        if (myRef.current && bootstrapComponents) {
            window.__litium.bootstrapComponents();
            }
        },[])
    
    return (
        <Carousel {...CarouselSettings} ref={myRef}>
            {values.map((value, index) => (
                <div
                    key={`figure${index}`}
                    dangerouslySetInnerHTML={{
                        __html: value.html,
                    }}
                ></div>
            ))}
        </Carousel>
    )
};

export default Slider;
